var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1003",
    "data-name": "Rectangle 1003",
    width: 102,
    height: 102,
    transform: "translate(1326 4136)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_homeappliance",
    transform: "translate(-1326 -4136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kitchen",
    transform: "translate(1330.999 4141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M89.539,96H62.222A1.518,1.518,0,0,0,60.7,97.518v34.9H27.317V127.87a1.518,1.518,0,0,0-1.518-1.518H21.246v3.035h3.035v3.035h-6.07v-6.07H15.176v6.07H9.106v-3.035h3.035v-3.035H7.588A1.518,1.518,0,0,0,6.07,127.87v4.553H1.518A1.518,1.518,0,0,0,0,133.94v33.387a1.518,1.518,0,0,0,1.518,1.518H89.539a1.518,1.518,0,0,0,1.518-1.518V97.518A1.518,1.518,0,0,0,89.539,96Zm-25.8,3.035H88.021v18.211H63.739ZM60.7,141.528H33.387v-6.07H60.7Zm-57.669-6.07H30.352v6.07H3.035Zm0,9.106H30.352V165.81H3.035Zm30.352,0H45.528V165.81H33.387Zm15.176,0H60.7V165.81H48.563ZM63.739,165.81V120.282H88.021V165.81Zm0,0",
    transform: "translate(0 -77.789)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M352,144h3.035v6.07H352Zm0,0",
    transform: "translate(-285.225 -116.683)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M352,256h3.035v6.07H352Zm0,0",
    transform: "translate(-285.225 -207.437)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M35.035,313.518A1.518,1.518,0,1,1,33.518,312,1.518,1.518,0,0,1,35.035,313.518Zm0,0",
    transform: "translate(-25.93 -252.814)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6209",
    "data-name": "Path 6209",
    d: "M67.035,313.518A1.518,1.518,0,1,1,65.518,312,1.518,1.518,0,0,1,67.035,313.518Zm0,0",
    transform: "translate(-51.859 -252.814)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6210",
    "data-name": "Path 6210",
    d: "M99.035,313.518A1.518,1.518,0,1,1,97.518,312,1.518,1.518,0,0,1,99.035,313.518Zm0,0",
    transform: "translate(-77.789 -252.814)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6211",
    "data-name": "Path 6211",
    d: "M131.035,313.518A1.518,1.518,0,1,1,129.518,312,1.518,1.518,0,0,1,131.035,313.518Zm0,0",
    transform: "translate(-103.718 -252.814)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6212",
    "data-name": "Path 6212",
    d: "M1.518,28.835H31.87a1.518,1.518,0,0,0,1.518-1.518V22.764a1.518,1.518,0,0,0-.445-1.073l-6.07-6.07a1.518,1.518,0,0,0-1.073-.445H24.282V1.518A1.518,1.518,0,0,0,22.764,0H10.623A1.518,1.518,0,0,0,9.106,1.518V15.176H7.588a1.518,1.518,0,0,0-1.073.445l-6.07,6.07A1.518,1.518,0,0,0,0,22.764v4.553A1.518,1.518,0,0,0,1.518,28.835Zm10.623-25.8h9.106V15.176H12.141ZM3.035,23.393l5.181-5.181H25.171l5.181,5.181V25.8H3.035Zm0,0",
    transform: "translate(0 0)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6213",
    "data-name": "Path 6213",
    d: "M51.729,368H33.518A1.518,1.518,0,0,0,32,369.518v12.141a1.518,1.518,0,0,0,1.518,1.518H51.729a1.518,1.518,0,0,0,1.518-1.518V369.518A1.518,1.518,0,0,0,51.729,368Zm-1.518,12.141H35.035v-9.106H50.211Zm0,0",
    transform: "translate(-25.93 -298.19)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6214",
    "data-name": "Path 6214",
    d: "M232,312h6.07v3.035H232Zm0,0",
    transform: "translate(-187.989 -252.814)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6215",
    "data-name": "Path 6215",
    d: "M208,392h3.035v6.07H208Zm0,0",
    transform: "translate(-168.542 -317.638)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6216",
    "data-name": "Path 6216",
    d: "M272,392h3.035v6.07H272Zm0,0",
    transform: "translate(-220.401 -317.638)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6217",
    "data-name": "Path 6217",
    d: "M185.518,37.94h9.106a1.518,1.518,0,0,0,1.518-1.518V34.9a6.07,6.07,0,0,0-4.553-5.855V0h-3.035V29.05A6.07,6.07,0,0,0,184,34.9v1.518A1.518,1.518,0,0,0,185.518,37.94Zm4.553-6.07a3.035,3.035,0,0,1,3.035,3.035h-6.07A3.035,3.035,0,0,1,190.07,31.869Zm0,0",
    transform: "translate(-149.095)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M241.518,25.8h9.106a1.518,1.518,0,0,0,1.518-1.518V22.764a6.07,6.07,0,0,0-4.553-5.855V0h-3.035V16.909A6.07,6.07,0,0,0,240,22.764v1.518A1.518,1.518,0,0,0,241.518,25.8Zm4.553-6.07a3.035,3.035,0,0,1,3.035,3.035h-6.07A3.035,3.035,0,0,1,246.07,19.729Zm0,0",
    transform: "translate(-194.472 0)",
    fill: "#f9556d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs4);
export default __webpack_public_path__ + "static/media/ss4.333ea02b0372e913e78250add4c48971.svg";
export { ForwardRef as ReactComponent };